module.exports = __webpack_public_path__ + "img/slide-15.281598d0.png";